import React from 'react';
import { Container, Button } from 'react-bootstrap';
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPrint, faDownload } from '@fortawesome/free-solid-svg-icons';
import CentredSpinner from '../../Components/CentredSpinner';

interface HTMLReportAreaProps {
    loadingReport: boolean,
    report: string | undefined,
    downloadName: string,
}

function HTMLReportArea({ loadingReport, report, downloadName }: HTMLReportAreaProps) {
    const { t } = useTranslation();

    const printReport = () => {
        let wnd = window.open();
        if (wnd != null && report) {
            wnd.document.body.innerHTML = report;
            wnd.print();
            wnd.close();
        }
    };

    const downloadReport = () => {
        const element = document.createElement('a');
        const file = new Blob([report as BlobPart], { type: 'text/html; charset=utf-8' });
        const url = URL.createObjectURL(file);
        element.href = url;
        element.download = downloadName;
        element.click();
    };

    return (
        <Container>
            <div className="d-flex flex-column">
                {loadingReport
                    ? <CentredSpinner />
                    :
                    <>
                        {report &&
                            <>
                                <div className="ms-auto" >
                                    <Button onClick={printReport} className="me-1"><FontAwesomeIcon icon={faPrint} className="me-1" />{t("Application.Controls.Print")}</Button>
                                    <Button onClick={downloadReport} className="me-1"><FontAwesomeIcon icon={faDownload} className="me-1" />{t("Application.Controls.Download")}</Button>
                                </div>
                                <div dangerouslySetInnerHTML={{ __html: report }} />
                            </>
                        }
                    </>
                }
            </div>
        </Container>
    );
}

export default HTMLReportArea;
